import apiInstance from "../api";

export const getDelayedPosts = offset => {
    console.log('API CALLED...');
    return apiInstance().get(`/delayed_campaign?offset=${offset}&limit=20`);
    // return apiInstance().get(`http://apidev2.myclout.com/v1.3/delayed_campaign?offset=${offset}&limit=20`);
    // return;
};
